module.exports = __webpack_public_path__ + "static/doc-img-a8c932b2f1959e89f1ac0f774fd7e0a8.jpg";